/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e={geodesic:0,loxodrome:1,"great-elliptic":2,"normal-section":3,"shape-preserving":4};export{e as geodeticCurveType};
